import { render, staticRenderFns } from "./CFormPageContent.vue?vue&type=template&id=755d16c0&scoped=true&"
import script from "./CFormPageContent.vue?vue&type=script&lang=ts&"
export * from "./CFormPageContent.vue?vue&type=script&lang=ts&"
import style0 from "./CFormPageContent.vue?vue&type=style&index=0&id=755d16c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755d16c0",
  null
  
)

export default component.exports